export const repUserPermissions = [
    '/manageAccount',
    '/selectBusinessLocation',
    '/repItems/list',
    '/repVendors/list',
    '/repOrders/list',
    '/repSavedOrders/list',
    '/ignoreComments'
]